import React from "react";

// DropdownMenuBox component renders a grid of selectable items
const DropdownMenuBox = ({ menu, onSelect }) => {
  return (
    <div className="dropdown__lists-grid">
      {/* Container for the grid of dropdown items */}
      {menu.map(
        (
          item // Iterate through each item in the menu array
        ) => (
          <div
            key={item.id}
            className={`dropdown__list-grid-item-wrapper ${
              item.selected ? "dropdown__list-grid-item--selected" : ""
            }`} // Wrapper for each grid item with conditional styling for selected state
          >
            <div
              className="dropdown__list-grid-item"
              style={item.style} // Inline style applied to the grid item
              onClick={() => onSelect(item)} // Click handler to select the item and trigger onSelect callback
            ></div>
          </div>
        )
      )}
    </div>
  );
};

export default DropdownMenuBox; // Export the DropdownMenuBox component for use in other parts of the application
